const SetRootProperty = () => {
  const root = document.querySelector(':root');
  root.style.setProperty('--view-width', document.body.clientWidth + 'px');
};

export { SetRootProperty };
